import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ReactiveService} from '../../../projects/api/src/reactive-service.abstract';


@Injectable()
export class ParentApiService extends ReactiveService {

  timeout = 2 * 60 * 1000; // 5 минут

  cache: {
    [k: string]: {
      time: number;
      data: Observable<any> | any;
    };
  } = {};


  getCache(name) {

    if (this.cache[name] && this.cache[name].time > Date.now() - this.timeout) {
      return this.cache[name].data;
    } else {
      return null;
    }
  }

  setCache(name, data) {
    this.cache[name] = {
      time: Date.now(),
      data
    };
  }
}


export interface SingleRESTService<T> {
  create(data: T): Observable<T>;

  save(id: number, data: T): Observable<T>;
}

export interface MultipleRESTService<T> {
  getAll(): Observable<T>;

  updateGroup?(ids: number[], data): Observable<T>;

  deleteGroup(ids: number[] | T): Observable<string>;
}
